module.exports = __webpack_public_path__ + "img/zertologo-small.ea614eec.png";